export class LoadPhlebotomy {
  public static readonly type = '[Documents] Load Phlebotomy';
}

export class LoadForms {
  public static readonly type = '[Documents] Load Forms';
}

export class LoadDownloads {
  public static readonly type = '[Documents] Load Downloads';
}
